/**
 * Sessao do site. A senha NAO existe mais no front: antes ela estava escrita
 * aqui, portanto dentro do JavaScript publico, e a API respondia tudo sem pedir
 * nada. Agora quem confere e o servidor, que devolve um cookie HttpOnly — o
 * navegador manda o cookie sozinho em cada chamada da mesma origem.
 */
export type Nivel = 'funcionario' | 'admin';

export async function nivelAtual(): Promise<Nivel | null> {
  try {
    const r = await fetch('/api/sessao');
    const d = (await r.json()) as { nivel?: Nivel | null };
    return d.nivel ?? null;
  } catch {
    return null;
  }
}

export type ResultadoLogin =
  | { ok: true; nivel: Nivel }
  | { ok: false; motivo: 'senha' | 'bloqueado' | 'rede' };

export async function entrar(senha: string): Promise<ResultadoLogin> {
  try {
    const r = await fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ senha }),
    });
    if (r.status === 429) return { ok: false, motivo: 'bloqueado' };
    if (!r.ok) return { ok: false, motivo: 'senha' };
    const d = (await r.json()) as { nivel: Nivel };
    return { ok: true, nivel: d.nivel };
  } catch {
    return { ok: false, motivo: 'rede' };
  }
}
